import React from "react";

export const PackagesTab = () => {
	return <div>PackagesTab</div>;
};
